module.exports = __webpack_public_path__ + "img/freespin_multiplier.75239ed9.png";